export const environment = {
  production: false,
  envName: 'sandbox',

  apiUrl: 'https://sandbox-api.platiniumrealty.com/api',
  broadcastingAuthUrl: 'https://sandbox-api.platiniumrealty.com/broadcasting/auth',

  useBranchIconUrl: false,

  reverb: {
    key: '',
    host: 'sandbox-reverb.platiniumrealty.com',
    port: 443,
    scheme: 'https',
  },
};